// src/components/Common/ColorSettings.jsx

import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import ColorSettingsContext from './ColorSettingsContext';
import { DataContext } from '../../DataContext';

const ColorSettings = ({ children }) => {
  const { appSettings, appSettingsLoading } = useContext(DataContext);

  // Function to calculate a shade of a color
  const shadeColor = (color, percent) => {
    // ... [Your existing shadeColor function]
  };

  useEffect(() => {
    if (!appSettingsLoading && appSettings && appSettings.primaryColor) {
      const primaryColor = appSettings.primaryColor;
      const secondaryColor = shadeColor(primaryColor, -30);

      // Set CSS variables
      document.documentElement.style.setProperty('--main-color', primaryColor);
      document.documentElement.style.setProperty('--secondary-color', secondaryColor);

      console.log('Set CSS variables:', {
        '--primary-color': primaryColor,
        '--secondary-color': secondaryColor,
      });
    }
  }, [appSettings, appSettingsLoading]);

  return (
    <ColorSettingsContext.Provider
      value={{
        appSettings,
        loading: appSettingsLoading,
      }}
    >
      {children}
    </ColorSettingsContext.Provider>
  );
};

export default ColorSettings;
